import qs from 'qs';
// 配置API接口地址
// var rootLocal = 'http://192.168.0.99/h5'; // 评分系统内网版接口域名
var rootLocal = 'http://api.cca.net'; // 评分系统内网版接口域名
// var root = 'http://192.168.0.99/cca-api'; // 评分系统本地服务端接口
// var root = 'http://api.cca.net/';
var root = 'https://api.ccachina.net/';
// var root = 'https://dx-api.ccachina.net/';
// var root = 'https://japi3.ccachina.net/';
// var root = 'https://cca-api.dierqudao.com/';
// var root = 'http://api2.ccachina.net/';
// var root = 'https://cca-api.dierqudao.com/';
var h5Root = 'https://h5.ccachina.net/cca-h5/dist/';
var PcRoot = 'https://pc.ccachina.net/cca-www/dist/';
// var h5Root = 'https://h5.cca.dierqudao.com/cca-h5/dist/';
var h5DevRoot = 'http://h5.loc:8080/cca-h5/dist/';
// var wsRoot = 'ws://cca.net:2346';
var wsRoot = 'wss://api-test.cca.dierqudao.com/wss';
window.root = root;
window.rootLocal = rootLocal;
window.wsRoot = wsRoot;
window.h5Root = h5Root;
window.PcRoot = PcRoot;
window.h5DevRoot = h5DevRoot;
// 引用axios
var axios = require('axios');

// 自定义判断元素类型JS
function toType(obj) {
    return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}

// 参数过滤函数
function filterNull(o) {
    for (var key in o) {
        if (o[key] === null) {
            delete o[key]
        }
        if (toType(o[key]) === 'string') {
            o[key] = o[key].trim()
        } else if (toType(o[key]) === 'object') {
            o[key] = filterNull(o[key])
        } else if (toType(o[key]) === 'array') {
            o[key] = filterNull(o[key])
        }
    }
    return o
}

/*
 接口处理函数
 这个函数每个项目都是不一样的，我现在调整的是适用于
 https://cnodejs.org/api/v1 的接口，如果是其他接口
 需要根据接口的参数进行调整。参考说明文档地址：
 https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
 主要是，不同的接口的成功标识和失败提示是不一致的。
 另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
 */

function apiAxios(method, url, params, success, failure,canNull) {
    console.log('canNull',canNull)
    if (params) {
        if(canNull){

        }else{
            params = filterNull(params)
        }
    } else {
        params = {}
    }
    console.log('params',params)


    if (localStorage.getItem('_seller_id')) {
        params._seller_id = localStorage.getItem('_seller_id');
    }
    if (localStorage.getItem('_pspt')) {
        params._pspt = localStorage.getItem('_pspt');
    }
    if (localStorage.getItem('_token')) {
        params._pspt = localStorage.getItem('_token');
    }
    if (localStorage.getItem('_phone')) {
        params._phone = localStorage.getItem('_phone');
    }
    if (localStorage.getItem('_closecode')) {
        params._closecode = localStorage.getItem('_closecode');
    }

    
    console.log('JSON.stringify(params)',JSON.stringify(params))

    // return ;
    /* console.log('localStorage.getItem(\'_token\')');
     console.log(localStorage.getItem('_token'));
     console.log(localStorage.getItem('_business_id'));*/
    axios({
            method: method,
            url: url,
            // data: method === 'POST' || method === 'PUT' ? qs.stringify(params) : null,
            data: method === 'POST' || method === 'PUT' ? JSON.stringify(params) : null,
            params: method === 'GET' || method === 'DELETE' ? params : null,
            // baseURL: root,
            // 动态更改baseURL 20211213
            baseURL: localStorage.getItem('_is_local') == 1 ? rootLocal : root,
            crossDomain: true,
            withCredentials: true,
            // transformRequest: [function (data) {
            //   // Do whatever you want to transform the data
            //   let ret = ''
            //   for (let it in data) {
            //     ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            //   }
            //   return ret
            // }],
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Access-Token': localStorage.getItem('_token'),
                'Business-Token': localStorage.getItem('_business_id'),
            }
        })
        .then(function(res) {
            if (res.data.success === true) {
                if (success) {
                    success(res.data);
                }
            } else {
                console.log('error', res);

                if (res.data.success == false && res.data.code == 401) {}

                if (res.data.success == false && res.data.code == 555) {
                    window.selfVue.$router.push({path: "/update"})
                    return
                }
                if (failure) {
                    failure(res.data);
                } else {
                    window.selfVue.$toast(res.data.msg || "不好意思出错啦");
                    // window.alert('error: ' + JSON.stringify(res.data));
                }
            }
        })
        // .catch(function (err) {
        //   let res = err.response;
        //   if (err) {
        //     window.alert('api error, HTTP CODE: ' + JSON.stringify(err));
        //     return
        //   }
        // })
}


function apiAxiosUpload(method, url, params, success, failure) {

    console.log(params, params.get('upfile'));
    axios({
            method: method,
            url: url,
            data: params,
            params: params,
            baseURL: root,
            crossDomain: true,
            withCredentials: true,
            // transformRequest: [function (data) {
            //   // Do whatever you want to transform the data
            //   let ret = ''
            //   for (let it in data) {
            //     ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            //   }
            //   return ret
            // }],
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(function(res) {
            if (res.data.success === true) {
                if (success) {
                    success(res.data);
                }
            } else {
                console.log('error', res);

                if (res.data.success == false && res.data.code == 401) {}
                if (failure) {
                    failure(res.data);
                } else {
                    window.selfVue.$toast(res.data.msg || "不好意思出错啦");
                    // window.alert('error: ' + JSON.stringify(res.data));
                }
            }
        })
        // .catch(function (err) {
        //   let res = err.response;
        //   if (err) {
        //     window.alert('api error, HTTP CODE: ' + JSON.stringify(err));
        //     return
        //   }
        // })
}

// 返回在vue模板中的调用接口
export default {
    get: function(url, params, success, failure,canNull) {
        return apiAxios('GET', url, params, success, failure,canNull)
    },
    post: function(url, params, success, failure,canNull) {
        console.log('canNull',canNull)
        // return ;
        return apiAxios('POST', url, params, success, failure,canNull)
    },
    put: function(url, params, success, failure,canNull) {
        return apiAxios('PUT', url, params, success, failure,canNull)
    },
    delete: function(url, params, success, failure,canNull) {
        return apiAxios('DELETE', url, params, success, failure,canNull)
    },
    upload: function(url, params, success, failure,canNull) {
        return apiAxiosUpload('POST', url, params, success, failure,canNull)
    }
}


// WEBPACK FOOTER //
// ./src/api/index.js